// @ts-nocheck
import apiClient from "../utils/apiClient";

const pincodeApi = {

  getPincodes: async () => {
    const response = await apiClient.get("/api/pincodes");

    return Array.isArray(response.data) ? response.data : [];
  },

  isAvailable: async (pinCode) => {
    const normalizedPinCode = String(pinCode || "").trim();

    if (!/^[1-9][0-9]{5}$/.test(normalizedPinCode)) {
      return false;
    }

    const response = await apiClient.get(
      `/api/pincodes/available/${encodeURIComponent(normalizedPinCode)}`
    );

    return Boolean(response.data?.available);
  },

  createPincode: async (data) => {
    const response = await apiClient.post("/api/pincodes", data, {
      forceAuth: true,
    });

    return response.data;
  },

  updatePincode: async (id, data) => {
    const response = await apiClient.put(`/api/pincodes/${id}`, data, {
      forceAuth: true,
    });

    return response.data;
  },

  deletePincode: async (id) => {
    await apiClient.delete(`/api/pincodes/${id}`, {
      forceAuth: true,
    });
  },
};

export default pincodeApi;
